export const ROLE_COMPANY_ADMIN = 'CA';
export const ROLE_EXECUTIVE = 'E';
export const ROLE_ADMIN = 'A';
export const ROLE_TABLET_USER = 'TU';
export const ROLE_COCKPIT_USER = 'CU';
export const ROLE_REPORT_USER = 'RU';
